export const redirectToAuth = () => {
    /**
     * window.location is technically read-only and of type Location, so assigning it to a string is technically incorrect.
     * https://developer.mozilla.org/en-US/docs/Web/API/Window/location
     *
     * Typescript doesn't like us setting it to a string, so we need to redirect using window.location.href instead.
     * https://github.com/microsoft/TypeScript/issues/19277#issuecomment-358085437
     */
    window.location.href = process.env.AUTH_PATH || '';
};
